import type { RunSummary } from '../../../core/run';
import type { Content } from '../../../data/schema';
import { loadContent } from '../../../data/content';

const content = loadContent();

/** Nom du boss de l'étage (premier monstre `boss` de ses vagues de boss), pour le titre de victoire. */
export function floorBossName(c: Content, floorId: string): string | null {
  const floor = c.floors[floorId];
  for (const w of floor?.bossWaves ?? []) for (const g of w.monsters) { const m = c.monsters[g.id]; if (m?.boss) return m.name; }
  return null;
}

export function EndPanel({ summary, onReplay, onHub }: { summary: RunSummary; onReplay: () => void; onHub: () => void }) {
  const boss = floorBossName(content, summary.floorId);
  const victory = boss ? `Victoire ! ${boss} est vaincu` : 'Victoire !';
  return (
    <div class="panel end-panel">
      <h2>{summary.outcome === 'victory' ? victory : 'Vous êtes mort'}</h2>
      <p>Salles : {summary.roomsCleared} / 6 · Kills : {summary.kills} · Niveau {summary.level} · Kamas : {summary.kamas}</p>
      {summary.practice
        ? <p class="practice">Run d'entraînement : aucune progression enregistrée</p>
        : <p class="reflets">+{summary.refletsEarned} Reflets Oniriques</p>}
      <div class="end-actions">
        <button onClick={onReplay}>Rejouer</button>
        <button onClick={onHub}>Retour au Songe</button>
      </div>
    </div>
  );
}
